<template>
<div class="content">
<van-nav-bar @click-left="onClickLeft" @click-right="onClickRight">
  <template #left>
    <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
  </template>
  <template #right>
    <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
  </template>
</van-nav-bar>
<!--  <navBar />-->
<van-list v-if="recordList.length"  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
  <div class="list">
    <div class="item left-justifying" v-for="(item,index) in recordList" :key="index" style="align-items: self-start;">
      <img :src="require('../../assets/'+appTheme+'/cz_icon.png')" alt="" />
      <div class="content-box justify-align">
        <div class="content-box-sec">
          <div class="title">充值</div>
          <div class="date">{{item.paid_at}}</div>
        </div>
        <div class="price">￥{{item.amount}}</div>
      </div>
    </div>
  </div>
</van-list>
<div style="text-align: center;margin-top: 20vw;" v-else>暂无数据</div>
</div>
</template>

<script>
import { getRecordList } from '@/api/wallet'
// import navBar from "@/components/navBar";
export default {
  name: "billList",
  components:{
    // navBar
  },
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      recordList: [],
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: 'null',
    }
  },
  beforeCreate: function() {
    // console.log('1')
    window.document.body.style.backgroundColor= '#fff'
    window.document.body.style.height= 'auto'
  },
  beforeDestroy: function() {
    // console.log('2')
    window.document.body.style.backgroundColor= ''
  },
  created() {
    this.getList()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      getRecordList(data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          that.recordList = res.data.data
          // 加载状态结束
          this.loading = false;
          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data==0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      getRecordList(data).then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          var arr = this.recordList.concat(res.data.data);
          // console.log(arr.length)
          that.recordList = arr
          // 加载状态结束
          this.loading = false;
          if (that.recordList.length == res.data.total) { // 数据全部加载完成
            this.finished = true;
            // console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
body{
  height: auto!important;
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.list{
  padding: 0 24px;background: #fff;
  .item{
    position: relative;border-radius: 25px;padding: 20px;margin-top: 20px;
    img{
      width: 66px;height:66px;display: inline-block;margin-right: 20px; border-radius: 66px;
    }
    .content-box{width: 619px;padding-bottom: 20px;border-bottom: 1px solid #F0F0F0;
      font-size: 28px;color: #000000;
      .content-box-sec{
        width: 80%;
      }
      .title{
        text-align: left;font-size: 28px;color: #383838;
      }
      .date{
        color: #9D9D9D;font-size: 24px;text-align: left;margin-top: 10px;
      }
    }
    .price{
      font-size: 30px;
      font-weight: bold;
      color: #000000;
    }
    .content-box-sec{

    }

  }

}

</style>
